import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { SignedEditionDndaWorkflowStateUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type SignedEditionDndaWorkflowStateUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  name_es: string;
  name_esSelectedValue?: { displayId: string; id: string } | null;
  onName_esChange?: (value: string) => void;
  name_esError?: string;
  name_en: string;
  name_enSelectedValue?: { displayId: string; id: string } | null;
  onName_enChange?: (value: string) => void;
  name_enError?: string;
  name_pt: string;
  name_ptSelectedValue?: { displayId: string; id: string } | null;
  onName_ptChange?: (value: string) => void;
  name_ptError?: string;
  signedEditionDndaWorkflowStateUpdateStore: SignedEditionDndaWorkflowStateUpdateStore;
};

export const SignedEditionDndaWorkflowStateUpdateForm: React.FC<SignedEditionDndaWorkflowStateUpdateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name_es = "",
      name_esError,
      onName_esChange = () => {},
      name_en = "",
      name_enError,
      onName_enChange = () => {},
      name_pt = "",
      name_ptError,
      onName_ptChange = () => {},
      signedEditionDndaWorkflowStateUpdateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelUpdatedEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="SignedEditionDndaWorkflowState"
              mode="update"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name_es":
                    onName_esChange?.(valor);
                    break;
                  case "name_en":
                    onName_enChange?.(valor);
                    break;
                  case "name_pt":
                    onName_ptChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={signedEditionDndaWorkflowStateUpdateStore.getCardErrors(
                "null"
              )}
              title={langStore.groupSignedEditionDndaWorkflowStateLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name_es}
                  error={Boolean(name_esError)}
                  warning={
                    !name_esError &&
                    Boolean(
                      signedEditionDndaWorkflowStateUpdateStore.warnings[
                        "name_es"
                      ]
                    )
                  }
                  helperText={
                    name_esError ||
                    signedEditionDndaWorkflowStateUpdateStore.warnings[
                      "name_es"
                    ]?.message
                  }
                  label={
                    langStore.SignedEditionDndaWorkflowStateNameLabel + " (es)"
                  }
                  onChange={(value: string) => onName_esChange(value)}
                />
                <InputString
                  value={name_en}
                  error={Boolean(name_enError)}
                  warning={
                    !name_enError &&
                    Boolean(
                      signedEditionDndaWorkflowStateUpdateStore.warnings[
                        "name_en"
                      ]
                    )
                  }
                  helperText={
                    name_enError ||
                    signedEditionDndaWorkflowStateUpdateStore.warnings[
                      "name_en"
                    ]?.message
                  }
                  label={
                    langStore.SignedEditionDndaWorkflowStateNameLabel + " (en)"
                  }
                  onChange={(value: string) => onName_enChange(value)}
                />
                <InputString
                  value={name_pt}
                  error={Boolean(name_ptError)}
                  warning={
                    !name_ptError &&
                    Boolean(
                      signedEditionDndaWorkflowStateUpdateStore.warnings[
                        "name_pt"
                      ]
                    )
                  }
                  helperText={
                    name_ptError ||
                    signedEditionDndaWorkflowStateUpdateStore.warnings[
                      "name_pt"
                    ]?.message
                  }
                  label={
                    langStore.SignedEditionDndaWorkflowStateNameLabel + " (pt)"
                  }
                  onChange={(value: string) => onName_ptChange(value)}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
